import resumesRouter from './resumes'
import helperRouter from './helper'
import recruit from './recruit'
import statistics from './statistics'
import dashboard from './dashboard'
import management from './management'
import user from './user'
import banner from './banner'
import train from './train'

export default [
    ...resumesRouter,
    ...helperRouter,
    ...recruit,
    ...statistics,
    ...dashboard,
    ...management,
    ...user,
    ...banner,
    ...train
]


// WEBPACK FOOTER //
// ./src/router/router/index.js